<template>
  <div id="app" v-bind:class="vista">
    <top-bar></top-bar>
    <div class="router-container">
      <router-view />
      <app-footer v-if="footerText && !loading" :text="footerText"></app-footer>
    </div>
    <lottie-loader v-if="loading" />
  </div>
</template>

<script>
import AppFooter from "@/components/core/AppFooter";
import TopBar from "@/components/core/TopBar";
import _get from "lodash/get";
import LottieLoader from "@/components/core/LottieLoader";
export default {
  name: "App",
  components: { TopBar, AppFooter, LottieLoader },
  data() {
    return {
      params: window.location.href.substring(window.location.href.indexOf("?")),
      vista: null,
    };
  },
  computed: {
    footerText() {
      let legales =
        this.vista == "oferta"
          ? _get(
              this.$store.state,
              "paquetesBeneficios.descripcionLegales",
              null
            )
          : null;
      let pasoFooter = this.config.pasos[this.vista]
        ? this.config.pasos[this.vista].footerText
        : null;
      if (pasoFooter === null) {
        return null;
      }
      return legales || pasoFooter || _get(this.config, "footerText", null);
    },
    loading() {
      return this.$store.state.isLoading;
    },
  },
  mounted() {
    this.$store.watch(
      this.$store.getters.getRoute,
      (route) => {
        // Obtengo el name de la vista para agregar clase general al div#app
        this.vista = route.meta.name;
      },
      { immediate: true }
    );
  },
};
</script>

<style>
@import "../node_modules/bootstrap/dist/css/bootstrap.css";
@import "../node_modules/bootstrap-vue/dist/bootstrap-vue.css";
@import "style/base.css";
@import "style/media.css";
@import "style/grid.css";

#app {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
  margin: auto;
}

.container {
  width: 100%;
  margin: 0 auto;
  max-width: 1200px;
}
div.router-container {
  padding-top: 90px;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 17px;
  padding-right: 17px;
}

/* Estilos globales para cada paso usando la clase con el nombre de la ruta */
#app.thank {
  background: #043263;
  /* HACK: Problema con overflow por no poder
  dar color de fondo al body
  doy scroll al elemento #app */
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
#app.thank .router-container {
  min-height: 0;
}

@media screen and (min-width: 600px) {
  div.router-container {
    /*El padding debe incluir la top bar + padding de contenedor y dar una distancia de 60 px
    entre el topbar y el primer título 
    padding = altura top bar - 17px + 60px;
    */
    padding-top: 103px;
    min-height: 100%;
  }
}
</style>
